module.exports = __webpack_public_path__ + "media/29072019_patrimoinephilippenoni.693e88a3.mp3";